import { inject, observer } from 'mobx-react';
import React from 'react';

import { ChannelStatus } from '../../../../enums/ChannelStatus';
import { ChatStatusMessage, Disclaimer } from '../../styled';
import ChatError from '../ChatError/ChatError';

const MessageSectionDisabled = inject('chatStore')(
  observer((props) => {
    if (!props.chatStore.options) {
      props.chatStore.options = {};
    }
    if (!props.chatStore.status) {
      props.chatStore.status = ChannelStatus.Unknown;
    }

    const { status, error, errorRetry } = props.chatStore;

    return (
      <React.Fragment>
        <Disclaimer>
          By continuing to chat, you consent to this chat being recorded and stored in our chat service in accordance
          with our Privacy Policy.
        </Disclaimer>
        {error && <ChatError errorMessage={error.message} errorRetry={errorRetry} />}
        {status === ChannelStatus.Waiting && <ChatStatusMessage>Please wait while we connect you.</ChatStatusMessage>}
        {status === ChannelStatus.Transferred && (
          <ChatStatusMessage>Please wait while we transfer you to an agent.</ChatStatusMessage>
        )}
      </React.Fragment>
    );
  }),
);

export default MessageSectionDisabled;
